export default "__VITE_ASSET__f2e9f83e__"